var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var SuperBanner_1;
import * as React from "react";
import { observer } from "mobx-react";
import { getBannerClasses } from "../../helpers";
// components
import { TooltipApi } from "sb-resp-ui";
import { EventsManager } from "sb-js-extends";
// external components
import * as CMP from "./components";
import { reaction } from "mobx";
import { getInvisibleSpace, onDragStart, onDragEnd, onThrowComplete } from "./helpers";
import gsap from "gsap";
import Draggable from "gsap/Draggable";
import InertiaPlugin from "gsap/InertiaPlugin";
gsap.registerPlugin(Draggable);
gsap.registerPlugin(InertiaPlugin);
let SuperBanner = SuperBanner_1 = class SuperBanner extends React.Component {
    constructor(props) {
        super(props);
        this.changePageClickHandler = (e) => {
            const target = e.target;
            const index = Number(target.dataset.pageId);
            this.state.dataProvider.autoLoopStop();
            this.state.dataProvider.changePage(index);
            this.state.dataProvider.setClicked(true);
        };
        this.onClickArrowsHandler = (direction) => {
            this.state.dataProvider.autoLoopStop();
            this.state.dataProvider.setClicked(true);
            this.state.dataProvider["scroll" + direction]();
            this.state.dataProvider.updatePagination();
            this.state.dataProvider.shouldScroll(this.nodes);
        };
        this.getOnBetBtnClickHandler = (selection, bsUtilItems) => {
            return (() => {
                this.state.dataProvider.addToSlipTranspiler(selection, bsUtilItems);
            }).bind(this);
        };
        this.dict = props.dict;
        this.cms = props.dataProvider.provider.dataFacade.cms;
        this.state = {
            dataProvider: props.dataProvider
        };
        this.isSingleItemOrMobileView = !this.cms.DisplayMultipleItems || this.cms.DisplayMobileMode;
        this.tooltip = TooltipApi.getInstance().setMessage(this.dict.TooltipMessage);
        this.availItemsChangeDisposer = reaction(() => this.state.dataProvider.itemsToDisplay.length, () => this.updateCalcs(), { delay: 500 });
        this.animateXDisposer = reaction(() => this.state.dataProvider.animation.x, this.animate.bind(this));
        this.nodes = {
            wrapper: React.createRef(),
            container: React.createRef()
        };
    }
    componentDidMount() {
        if (this.state.dataProvider.deviceDetect.isDesktop) {
            this.updateCalcs();
            window.addEventListener("resize", this);
            SuperBanner_1.eventsManager.addEventListener("onSideVisibilityChange", this, this.updateCalcs, true);
            SuperBanner_1.eventsManager.addEventListener("onBranchChanged", this, this.resetScroll, true);
            SuperBanner_1.eventsManager.addEventListener("onBranchRemoved", this, this.resetScroll, true);
            this.cms.UISetting.autoLoop.enabled && this.state.dataProvider.autoLoopStart();
            if (this.cms.UISetting.Draggable) {
                Draggable.create(this.nodes.container.current, {
                    type: "x",
                    inertia: true,
                    edgeResistance: 0.65,
                    snap: this.state.dataProvider.snap,
                    bounds: this.nodes.wrapper.current,
                    onDragStart,
                    onDragStartParams: [this.state.dataProvider],
                    onDragEnd,
                    onDragEndParams: [this.state.dataProvider],
                    onThrowComplete,
                    onThrowCompleteParams: [this.state.dataProvider],
                    zIndexBoost: false
                });
            }
        }
    }
    componentWillUnmount() {
        if (this.state.dataProvider.deviceDetect.isDesktop) {
            window.removeEventListener("resize", this);
            SuperBanner_1.eventsManager.removeEventListener("onSideVisibilityChange", this, true);
            SuperBanner_1.eventsManager.removeEventListener("onBranchChanged", this, true);
            SuperBanner_1.eventsManager.removeEventListener("onBranchRemoved", this, true);
            this.state.dataProvider.autoLoopStop();
            this.resetScroll();
        }
        this.availItemsChangeDisposer();
        this.animateXDisposer();
    }
    componentDidUpdate() {
        if (this.state.dataProvider.deviceDetect.isDesktop) {
            this.setupCalcs();
            this.state.dataProvider.shouldScroll(this.nodes);
        }
    }
    animate() {
        if (this.nodes.container.current) {
            gsap.to(this.nodes.container.current, this.state.dataProvider.animation);
        }
    }
    handleEvent(e) {
        typeof this[`on${e.type}`] === "function" && this[`on${e.type}`](e);
        if (e.type === "resize") {
            this.resetScroll();
            this.state.dataProvider.shouldScroll(this.nodes);
        }
    }
    setupCalcs() {
        if (this.nodes.wrapper.current && this.nodes.container.current) {
            this.state.dataProvider.setupCalcs(this.nodes.wrapper.current, this.nodes.container.current, this.cms.DisplayMultipleItems);
        }
    }
    updateCalcs() {
        this.setupCalcs();
        this.state.dataProvider.updatePagination();
        this.state.dataProvider.shouldScroll(this.nodes);
    }
    resetScroll() {
        this.state.dataProvider.setAnimationX(0);
        this.setupCalcs();
        this.state.dataProvider.currentPage = 0;
        this.state.dataProvider.updatePagination();
    }
    renderBlockLoader() {
        this.resetScroll();
        return React.createElement(CMP.SuperBannerLoader, null);
    }
    render() {
        const isDraggingClass = this.state.dataProvider.isDragging ? " rj-superbanner__wrapper--is-dragging" : "";
        const isDraggingDataUat = this.state.dataProvider.isDragging ? "wrapper-superbanner-dragging" : "wrapper-superbanner";
        const hasNotFullyVisibleItems = getInvisibleSpace(this.state.dataProvider.calcs) !== 0;
        const superBannerItemsProps = this.getSuperBannerItemsProps();
        const superBannerItemsPaginationProps = this.getSuperBannerPaginationProps();
        const renderArrows = this.getRenderArrows(hasNotFullyVisibleItems);
        const renderPagination = this.getRenderPagination(hasNotFullyVisibleItems);
        return this.state.dataProvider.buildUIData.length > 0 && (React.createElement("div", { className: this.getSupperBannerClasses(hasNotFullyVisibleItems) },
            React.createElement(CMP.WrapperShell, { autoLoopEnabled: this.cms.UISetting.autoLoop.enabled, autoLoopStart: this.state.dataProvider.autoLoopStart, autoLoopStop: this.state.dataProvider.autoLoopStop, isDesktop: this.state.dataProvider.deviceDetect.isDesktop },
                React.createElement("div", { className: `rj-superbanner__wrapper${isDraggingClass}`, ref: this.nodes.wrapper, "data-uat": isDraggingDataUat },
                    React.createElement("div", { className: "rj-superbanner__container", ref: this.nodes.container },
                        React.createElement("div", { className: "rj-superbanner__slider" },
                            React.createElement(CMP.SuperBannerItems, Object.assign({}, superBannerItemsProps)))))),
            renderArrows && React.createElement(CMP.SuperBannerArrows, { onClick: this.onClickArrowsHandler, scrollable: this.state.dataProvider.scrollable }),
            renderPagination && React.createElement(CMP.SuperBannerPagination, Object.assign({}, superBannerItemsPaginationProps))));
    }
    getSupperBannerClasses(hasNotFullyVisibleItems) {
        return getBannerClasses({
            scrollability: this.state.dataProvider.scrollable,
            isMultipleItemsModeEnabled: this.cms.DisplayMultipleItems,
            draggability: this.state.dataProvider.deviceDetect.isDesktop && hasNotFullyVisibleItems && this.cms.UISetting.Draggable,
            isMobileMode: this.cms.DisplayMobileMode
        });
    }
    getSuperBannerPaginationProps() {
        return {
            type: this.cms.DisplayMultipleItems ? "lines" : "dots",
            pages: this.state.dataProvider.pages,
            onClick: this.changePageClickHandler,
        };
    }
    getSuperBannerItemsProps() {
        return {
            items: this.state.dataProvider.buildUIData,
            itemWidth: this.state.dataProvider.itemWidth,
            displayMultipleItems: this.cms.DisplayMultipleItems,
            displayMobileMode: this.cms.DisplayMobileMode,
            isSingleItemOrMobileView: this.isSingleItemOrMobileView,
            liveIndicator: this.dict.LiveIndicator,
            tooltip: this.tooltip,
            ML: this.state.dataProvider.oddsFormatter.ML,
            Outright: this.state.dataProvider.oddsFormatter.Outright,
            viewAllButton: this.dict.ViewAllButton,
            onBetButtonClick: this.getOnBetBtnClickHandler,
            openGameTranspiler: this.state.dataProvider.provider.openGameTranspiler,
            onImageClick: this.state.dataProvider.provider.imageClickHandler,
            getSuperBannerItemModifier: this.state.dataProvider.getSuperBannerItemModifier,
            openRaceGame: this.state.dataProvider.provider.openRaceGame,
        };
    }
    getRenderPagination(hasNotFullyVisibleItems) {
        return this.state.dataProvider.deviceDetect.isDesktop
            && this.cms.UISetting.Pagination
            && hasNotFullyVisibleItems;
    }
    getRenderArrows(hasNotFullyVisibleItems) {
        return this.state.dataProvider.deviceDetect.isDesktop
            && hasNotFullyVisibleItems
            && this.cms.UISetting.useArrows;
    }
};
SuperBanner.eventsManager = new EventsManager();
SuperBanner = SuperBanner_1 = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], SuperBanner);
export { SuperBanner };
//# sourceMappingURL=SuperBanner.js.map